import React, { Component } from 'react'
import './switchvertical.scss'

class SwitchVertical extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isChecked: Boolean(props.isChecked) || false,
			type: props.type ? props.type : 'radio',
			idFirst: props.idFirst ? props.idFirst : '',
			idSecond: props.idSecond ? props.idSecond : '',
			for: props.for ? props.for : '',
			name: props.name ? props.name : 'name',
			labelFirst: props.labelFirst ? props.labelFirst : '',
			labelSecond: props.labelSecond ? props.labelSecond : '',
			state: props.state ? props.state : '',
			value: props.value ? props.value : '',
			labelClasses: props.labelClasses ? props.labelClasses : '',
			classes: props.classes ? props.classes : '',
			onChange: this.handleChange
		}
		this.handleChange = this.handleChange.bind(this)
	}

	componentDidMount() {
		if (this.state.value !== '') {
			this.state.value == this.state.idFirst ? this.setState({ isChecked: true }) : this.setState({ isChecked: false })
		} else {
			this.state.isChecked
				? this.setState({ value: this.state.idFirst })
				: this.setState({ value: this.state.idSecond })
		}
	}

	handleChange = (event) => {
		this.setState({ isChecked: !this.state.isChecked })
		this.setState({ value: event.target.value })
		this.props.onChange && this.props.onChange(event)
	}

	handleOptionChange = (event) => {
		this.setState({
			value: event.target.value
		})
	}

	render() {
		const classes = ['vbui--input', this.state.classes, this.state.state].join(' ')
		const labelClass = ['group vbui--toggle-switch-container', this.state.labelClasses, this.state.showIcon].join(' ')
		return (
			<div className={labelClass}>
				<div className="toggle-switch switch-vertical">
					<input
						id={this.state.idFirst}
						type={this.state.type}
						className={classes}
						name={this.state.name}
						checked={this.state.idFirst === this.state.value}
						onChange={this.state.onChange}
						value={this.state.idFirst}
					/>
					<label htmlFor={this.state.idFirst}>{this.state.labelFirst}</label>
					<input
						id={this.state.idSecond}
						type={this.state.type}
						className={classes}
						name={this.state.name}
						checked={this.state.idSecond === this.state.value}
						onChange={this.state.onChange}
						value={this.state.idSecond}
					/>
					<label htmlFor={this.state.idSecond}>{this.state.labelSecond}</label>
					<span className="toggle-outside">
						<span className="toggle-inside"></span>
					</span>
				</div>
			</div>
		)
	}
}

export default SwitchVertical
